module.exports = __webpack_public_path__ + "media/images/anchor_link02_sp-71e7fe18bb3db849b1a213723216d068.png";